import React, { useEffect } from 'react'

import Header from './Header'
import About from './About'
import Services from './Services'
import Plan from './Plan'
import Faq from './Faq'
import DownloadApp from './App'
import Contact from './Contact'
import Footer from './Footer'
import { useHistory } from 'react-router-dom'

export default function Home(props) {
	const history = useHistory();

	useEffect(() => {
		history.push('/login');
	},[])// eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
				<>
					<Header />
					<About />
					<Services />
					<Plan {...props} />
					<Faq />
					<DownloadApp />
					<Contact />
					<Footer />
				</>
		</>

	)
}